import { useEffect } from "react";
import { useProjects } from "@/hooks/useProjects";
import { toast } from "sonner";
import { useLanguage } from "@/contexts/LanguageContext";
import ProjectTabView from "@/components/ProjectTabView";

const ITEMS_PER_PAGE = 12;

const Projects = () => {
  const { t } = useLanguage();

  const {
    projects,
    meta,
    isLoading,
    isError,
    pagination,
    goToPage,
    projectDevelopers,
    isLoadingDevelopers,
    projectDeveloperId,
    handleDeveloperChange,
    countries,
    isLoadingCountries,
    countryCode,
    handleCountryChange,
  } = useProjects(ITEMS_PER_PAGE);

  // Set page title
  useEffect(() => {
    document.title = `Silvaconsult Registry | ${t("common.projects")}`;
  }, [t]);

  // Handle errors
  useEffect(() => {
    if (isError) {
      toast.error(t("common.error"), {
        description: t("common.noData"),
      });
    }
  }, [isError, t]);

  return (
    <div className="min-h-screen bg-[#f0f4f8] bg-[silvaconsult-primary-100]">
      <div className="container max-w-6xl mx-auto px-4 py-8">
        <div className="mb-6">
          <h1 className="text-2xl font-medium">{t("projects.title")}</h1>
          <p className="text-gray-500 mt-1">{t("projects.description")}</p>
        </div>

        <div className="bg-white rounded-xl shadow-sm">
          <div className="mt-6 border-t pt-6 p-6">
            <ProjectTabView
              projectDevelopers={projectDevelopers}
              projectDeveloperId={projectDeveloperId}
              handleDeveloperChange={handleDeveloperChange}
              isLoadingDevelopers={isLoadingDevelopers}
              countries={countries}
              countryCode={countryCode}
              handleCountryChange={handleCountryChange}
              isLoadingCountries={isLoadingCountries}
              projects={projects}
              isLoading={isLoading}
              meta={meta}
              onPageChange={goToPage}
              currentPage={pagination.page}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Projects;
